import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { MpsUserService } from '../../mps/services/mps-user.service';
import { homeRedirect } from './home-redirect';

/**
 * Guard protecting the /welcome route.
 * If the user is already onboarded (cgu_accepted_at is set), redirect them
 * to their role home — they should never see the welcome page again.
 * Otherwise, let them through so they can complete onboarding.
 */
export const appWelcomeGuard: CanActivateFn = () => {
  const router = inject(Router);
  const user = inject(MpsUserService).getUser();

  if (user?.cgu_accepted_at != null) {
    return router.navigateByUrl(homeRedirect());
  }

  return true;
};
